import React, { useEffect, useState } from "react";
import { apiCallResponse } from "src/_apiConfig/apiCall";
import {
  FilterContains,
  FilterContainsInsensitive,
} from "../common/FilterCondition";
import Auth from "src/auth";
import {
  CommonSearchExtra,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";
import DropDownCircle from "../common/controller/DropDown/Cricle";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import CommonList from "../common/CommonList";

const CfoList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [textField, settextField] = useState("emailId");
  const [order, setorder] = useState("asc");

  const [orderClick, setOrderClick] = useState(true);
  const [itemPerPage, setItemPerPage] = useState(10);

  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage

  // Your default search model
  const SearchFilterModel = {
    mobile: "",
    name: "",
    emailAddress: "",
    lotNo: "",
    street: "",
    circle: "",
  };

  const [search, setSearch] = useState(SearchFilterModel);

  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getCfoList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getCfoList(true);
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const reset = () => {
    setpageLimit(0);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";
    filter = FilterContainsInsensitive(filter, "name", search.name);
    filter = FilterContains(filter, "mobile", search.mobile);
    filter = FilterContainsInsensitive(filter, "emailId", search.emailAddress);
    filter = FilterContainsInsensitive(filter, "streetName", search.street);
    filter = FilterContains(filter, "circleName", search.circle);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`Circle_Master/getOfficers?${filterManage()}`).then(
        (res) => {
          if (res.success)
            paggingDisabledManage(parseInt(res.data.length) || 0);
        }
      );
    }
  };

  const getCfoList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      //setCriclePerPage(false);
      await apiCallResponse(
        `Circle_Master/getOfficers?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setuserData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
  };
  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    setpageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    setpageLimit(pageLimitSet);
  };
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };
  const searchControl = (
    <>
      <SCInput
        label={"Email Address :"}
        name={"emailAddress"}
        value={search.emailAddress}
        onChange={updateSearch}
      />
      <SCInput
        label={"Name :"}
        name={"name"}
        value={search.name}
        onChange={updateSearch}
      />
      <SCInput
        label={"Mobile No. :"}
        id={"mobile"}
        name={"mobile"}
        value={search.mobile}
        onChange={updateSearch}
      />
      <SCInput
        label={"Street Location :"}
        id={"street"}
        name={"street"}
        value={search.street}
        onChange={updateSearch}
      />
      <DropDownCircle
        isClear={isClear}
        name={"circle"}
        value={search.circle}
        onChange={updateSearch}
      />
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
    />
  );

  const fields = [
    {
      key: "emailId",
      label: TableHeaderSet("Email Address", "emailId"),
    },
    {
      key: "name",
      label: TableHeaderSet("Name", "name"),
    },
    {
      key: "mobile",
      label: TableHeaderSet("Mobile No", "mobile"),
    },
    {
      key: "circleName",
      label: TableHeaderSet("Circle Name", "circleName"),
    },
    {
      key: "Street",
      label: TableHeaderSet("Street Location", "streetName"),
    },
  ];
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Circle Forest Officer Search"
      loading={loading}
      path="/cfolist"
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
    />
  );
};
export default CfoList;
// Bidder/getBidders?$orderBy=emailId%20desc&$skip=3&$top=10
//   Bidder/getBidders?$filter=contains(emailId,'{aa}')%20emailId%20asc%20&$skip=0&$top=5
//  Bidder/getBidders?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${5}
